export default "__VITE_ASSET__C26vpB0c__"